import {
  ADD_STATISTICS,
  ADD_FINANCIAL_GROUPS,
  ADD_KYC_ITEMS,
  ADD_GROUP_MESSAGE_SETTINGS,
  ADD_GIFT_CARD_SETTINGS,
  ADD_NETWORKS
} from '../actions';

export const addGiftCardSettings = (payload) => ({
  type: ADD_GIFT_CARD_SETTINGS,
  payload,
});

export const addGroupMessageSettings = (payload) => ({
  type: ADD_GROUP_MESSAGE_SETTINGS,
  payload,
});

export const addStatistics = (payload) => ({
  type: ADD_STATISTICS,
  payload,
});

export const addFinancialGroups = (payload) => ({
  type: ADD_FINANCIAL_GROUPS,
  payload,
});

export const addKycItems = (payload) => ({
  type: ADD_KYC_ITEMS,
  payload,
});

export const addNetworks = (payload) => ({
  type: ADD_NETWORKS,
  payload,
});
